import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

export const useSavePersonSSN = (): UseMutationResult<
    void,
    Error,
    { personId: string; personUUID: string; ssn: string }
> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ personUUID, ssn }) => {
            const response = await fetch(apiUrl(`/person/save-ssn/${personUUID}`), {
                method: "POST",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify({
                    ssnumber: ssn,
                }),
            });
            await handleJsonApiError(response);
        },
        onSuccess: async (_, { personId }) => {
            await queryClient.invalidateQueries({
                queryKey: ["person", personId],
            });
        },
    });
};
